import { tokenManager } from "@babackapp/auth-client/utils";
import { getReturnWidgetBaseUrl } from "@babackapp/private-api-client/client/return-widget-client";
import { useQuery } from "@tanstack/react-query";

type WidgetAuthCheckUser = {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
};

export type WidgetAuthCheckResponseDto =
  | { isAuthenticated: true; user: WidgetAuthCheckUser }
  | { isAuthenticated: false; user?: undefined };

const NOT_AUTHENTICATED = { isAuthenticated: false } as const satisfies WidgetAuthCheckResponseDto;

export async function fetchWidgetAuthCheck(): Promise<WidgetAuthCheckResponseDto> {
  const merchantToken = tokenManager.getAccessToken();
  console.log("[widget-auth] fetchWidgetAuthCheck, token:", merchantToken ? "present" : "null", "cookie:", document.cookie);

  const base = getReturnWidgetBaseUrl().replace(/\/?$/, "/");
  const headers: HeadersInit = {};
  if (merchantToken) headers["Authorization"] = `Bearer ${merchantToken}`;

  // Always send credentials: 'include' — after requestStorageAccess() is granted,
  // Chrome includes the unpartitioned access_token cookie in credentialed requests
  // even when document.cookie is still empty. The server reads it from the cookie.
  const res = await fetch(`${base}public/widget/auth-check`, {
    headers,
    credentials: "include",
  });
  console.log("[widget-auth] auth-check response status:", res.status);
  if (!res.ok) return NOT_AUTHENTICATED;
  return res.json() as Promise<WidgetAuthCheckResponseDto>;
}

export function useWidgetAuthCheck() {
  return useQuery({
    queryKey: ["widget-auth-check"],
    queryFn: fetchWidgetAuthCheck,
    staleTime: 60_000,
    retry: false,
  });
}
